import React, { useEffect, useState, useContext, useRef } from "react";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import { Menu as MenuIcon, X, Mail, PhoneCall } from "react-feather";
import { Container, Box, Typography, Drawer, Grid } from "@mui/material";
import { CHANGE_LANG } from "context/actions/auth";
import { GlobalContext } from "context";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import useWindowSize from "utils/useWindowSize";
import { getPageList } from "context/actions/pages";
import { Facebook, Instagram } from "react-feather";

const HeaderHeight = 90;

const Header = () => {
  const { sizes } = useWindowSize();
  const { t } = useTranslation();
  const router = useRouter();
  const divRef = useRef(null);
  const divRef2 = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const { state, dispatch } = useContext(GlobalContext);
  const [showMenu, setShowMenu] = useState(false);
  const [menus, setMenus] = useState([]);
  const [absoluteMenus, setAbsoluteMenus] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        divRef.current &&
        !divRef.current.contains(event.target) &&
        !divRef2.current.contains(event.target)
      ) {
        setAbsoluteMenus([]);
      }
    };

    const handleScroll = () => {
      setScrollTop(window.pageYOffset);
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getMenus = async () => {
      const datas = await getPageList(true);
      if (datas.status === "success") {
        setMenus(datas.data);
      }
    };
    getMenus();
  }, []);

  const handleMenuButtonClick = () => {
    setShowMenu((prev) => !prev);
  };

  const handleDrawerClose = () => {
    setShowMenu(false);
  };

  const handleRoteClick = (menu) => {
    showMenu && handleDrawerClose();
    if ((menu.url && menu.url.charAt(0) === "/") || !menu.url) {
      router.push(menu.url ? menu.url : `/content/${menu.id}`);
    } else {
      window.open(menu.url, "_blank", "noopener,noreferrer");
    }
  };

  const RenderMenu = ({ position, menu, type = "header" }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <div
        onMouseEnter={() => setShowSubMenu(true)}
        onMouseLeave={() => setShowSubMenu(false)}
        style={{ position: "relative", cursor: "pointer" }}
      >
        <li
          style={{
            position: "relative",
            height:
              type === "drawer" ? 30 : position === menus.length - 1 ? 35 : 80,
            display: "flex",
            marginTop: position === menus.length - 1 ? 22.5 : 0,
            justifyContent: "left",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            // fontWeight: 500,
            fontSize: 18,
            borderRadius: 6,
            color: "#4f4235",

            fontFamily: "Philosopher",
            fontWeight: 800,
            backgroundColor:
              position === menus.length - 1
                ? showSubMenu
                  ? "#fff"
                  : "#fff"
                : "",
          }}
          className="transition-colors duration-300 cursor-pointer"
        >
          {menu.children && menu.children.length > 0 ? (
            menu.name
          ) : (
            <Link
              href={menu.url ? menu.url : `/content/${menu.id}`}
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              {menu.name}
            </Link>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: 63,
              left: position > 2 ? null : "0%",
              right: position > 2 ? "20%" : null,
              backgroundColor: "white",
              borderRadius: 10,
              zIndex: 100,
              boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
            }}
          >
            <ul style={{ position: "relative" }}>
              {menu.children.map((m, ind) => (
                <RenderSubMenu
                  key={m.id || ind}
                  menu={m}
                  showsMenu={showSubMenu}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  };

  const RenderSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <Box
        onMouseEnter={() => setShowSubMenu(true)}
        onMouseLeave={() => setShowSubMenu(false)}
        style={{ position: "relative" }}
      >
        <li
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: showsMenu ? "block" : "none",
            backgroundColor: showSubMenu ? "#bee0f8" : "#fff",
            paddingLeft: 40,
            paddingRight: 40,
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <Typography noWrap variant="body2" className="p-2">
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          ) : (
            <Link
              href={menu.url ? menu.url : `/content/${menu.id}`}
              target={
                (menu.url && menu.url.charAt(0) === "/") || !menu.url
                  ? "_self"
                  : "_blank"
              }
            >
              <Typography noWrap variant="body2" className="p-2">
                {i18n.language === "mn" ? menu.name : menu.nameEng}
              </Typography>
            </Link>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <div
            style={{
              position: "absolute",
              right: "95%",
              maxWidth: 600,
              top: 0,
              backgroundColor: "white",
              borderRadius: 10,
              zIndex: 101,
              boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.3)",
            }}
          >
            <ul style={{ position: "relative" }}>
              {menu.children.map((m, ind) => (
                <RenderSubMenu
                  key={m.id || ind}
                  menu={m}
                  showsMenu={showSubMenu}
                />
              ))}
            </ul>
          </div>
        )}
      </Box>
    );
  };

  const RenderToggleMenu = ({ menu, type = "header" }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return (
      <div onClick={() => setShowSubMenu(!showSubMenu)}>
        <li
          style={{
            position: "relative",
            height: type === "drawer" ? 30 : 80,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: 10,
            paddingRight: 10,
            cursor: "pointer",
            color: type === "drawer" ? "black" : "white",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {menu.children && menu.children.length > 0 ? (
            <>
              {i18n.language === "mn" ? menu.name : menu.nameEng}
              <div>{showSubMenu ? "-" : "+"}</div>
            </>
          ) : (
            <Typography
              variant="body4"
              sx={{
                color: "#000",
                fontWeight: 700,
                cursor: "pointer",
                marginRight: "46px",
                "&:hover": { color: "#a19d9d" },
              }}
              onClick={() => handleRoteClick(menu)}
            >
              {i18n.language === "mn" ? menu.name : menu.nameEng}
            </Typography>
          )}
        </li>
        {menu.children && menu.children.length > 0 && (
          <ul>
            {menu.children.map((m, ind) => (
              <RenderToggleSubMenu
                key={m.id || ind}
                menu={m}
                showsMenu={showSubMenu}
              />
            ))}
          </ul>
        )}
      </div>
    );
  };

  const RenderToggleSubMenu = ({ menu, showsMenu = true }) => {
    const [showSubMenu, setShowSubMenu] = useState(false);

    return showsMenu ? (
      <div>
        <li
          onMouseEnter={() => setShowSubMenu(true)}
          onMouseLeave={() => setShowSubMenu(false)}
          style={{
            position: "relative",
            color: "gray",
            cursor: "pointer",
            display: "flex",
            marginLeft: 30,
            padding: 10,
          }}
        >
          <Typography variant="h4" onClick={() => handleRoteClick(menu)}>
            {i18n.language === "mn" ? menu.name : menu.nameEng}
          </Typography>
        </li>
        {menu.children && menu.children.length > 0 && (
          <div style={{ position: "relative", marginLeft: 30 }}>
            {menu.children.map((m, ind) => (
              <RenderToggleSubMenu
                key={m.id || ind}
                menu={m}
                showsMenu={showSubMenu}
              />
            ))}
          </div>
        )}
      </div>
    ) : null;
  };

  return (
    <div style={{ paddingBottom: absoluteMenus.length ? 0 : 0 }}>
      <Container
        maxWidth={false}
        disableGutters
        sx={{ height: 35, backgroundColor: "#cba47e" }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box className="flex items-center">
            <Box className="flex items-center">
              <PhoneCall
                color="#fff"
                size={16}
                sx={{ ml: "auto", cursor: "pointer" }}
                onClick={handleMenuButtonClick}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  ml: 1,
                  mr: 2.5,
                  color: "#fff",
                  "&:hover": { color: "grey.600" },
                }}
              >
                +976 99020368
              </Typography>
            </Box>
            <Box className="flex items-center">
              <Mail
                color="#fff"
                size={16}
                sx={{ ml: "auto", cursor: "pointer" }}
                onClick={handleMenuButtonClick}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  mr: 2.5,
                  ml: 1,
                  color: "#fff",
                  "&:hover": { color: "grey.600" },
                }}
              >
                info@ezentravel.mn
              </Typography>
            </Box>
          </Box>

          <Link href="/contact">
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                mr: 2.5,
                color: "#fff",
                "&:hover": { color: "grey.600" },
              }}
            >
              {/* {t("send_feed")} */}
            </Typography>
          </Link>
          {state.auth?.lang === "mn" ? (
            <Box
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                i18n.changeLanguage("en");
                Cookies.set("chosen_lang", "en");
                dispatch({ type: CHANGE_LANG, data: "en" });
              }}
            >
              <Image
                width={20}
                height={20}
                src="/en.svg"
                alt="English"
                style={{
                  border: state.auth.lang === "en" ? "2px solid #fff" : "none",
                  borderRadius: 1,
                  marginRight: 4,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  color: "#fff",
                  "&:hover": { color: "grey.600" },
                }}
              >
                EN
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                i18n.changeLanguage("mn");
                Cookies.set("chosen_lang", "mn");
                dispatch({ type: CHANGE_LANG, data: "mn" });
              }}
            >
              <Box className=" flex flex-col z-[9893]">
                <a
                  href="https://www.facebook.com/profile.php?id=61579910966244"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Box className="bg-[#0966ff] h-[25px] w-[25px] flex justify-center items-center rounded-[50px]">
                    <Facebook color="#fff" size={18} />
                  </Box>
                </a>
              </Box>
              <Box className="ml-4 flex flex-col z-[9893]">
                <Box className="  flex justify-center items-center  cursor-pointer">
                  <a
                    href="https://www.instagram.com/ezen.travel/?fbclid=IwY2xjawMeTrxleHRuA2FlbQIxMABicmlkETFDQnJMM3BjVDNhOWNlNVZEAR7I1eNozW1aRIejDm6AqCm3BLqdbh7uoWyjlyd424r3xu4JYkMFh7ErL_CqBw_aem_ybliG3rEmxIdwnLlezaYxw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      width={25}
                      height={25}
                      src="/insta.jpg" // Path to Instagram image
                      alt="insta"
                      className="object-contain rounded-[50px]"
                    />
                  </a>
                </Box>
              </Box>

              <Box className="ml-4 flex flex-col z-[9893]">
                <a
                  href="https://www.tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    width={25}
                    height={25}
                    src="/tik.png" // Path to TikTok image
                    alt="tik"
                    className="object-contain rounded-[50px]"
                  />
                </a>
              </Box>
            </Box>
          )}
        </Container>
      </Container>
      <Container
        maxWidth={false}
        disableGutters
        ref={divRef2}
        sx={{
          height: HeaderHeight,
          backgroundColor: "#fff",
          borderBottom: "1px solid #cbcbcb75",
          position: scrollTop > 40 ? "fixed" : "absolute",
          top: scrollTop > 40 ? 0 : 40,
          zIndex: 9999,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: HeaderHeight,
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Link href="/">
            <Link href="/" passHref>
              <Box className="flex">
                <Image
                  width={70}
                  height={48}
                  src="/Logo.png"
                  alt="Logo"
                  priority
                  style={{ objectFit: "cover" }}
                />
                <Image
                  width={120}
                  height={48}
                  src="/names.png"
                  alt="Logo"
                  priority
                  style={{ objectFit: "contain", marginLeft: 10 }}
                />
              </Box>
            </Link>
          </Link>
          {sizes.sm ? (
            <>
              <MenuIcon
                color="#13285a"
                size={40}
                sx={{ ml: "auto", cursor: "pointer" }}
                onClick={handleMenuButtonClick}
              />
              <Drawer
                anchor="right"
                open={showMenu}
                onClose={handleDrawerClose}
                transitionDuration={{ enter: 500, exit: 500 }}
                PaperProps={{ sx: { width: "100vw" } }}
                sx={{ zIndex: 10000 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    p: 2.5,
                    height: "100%",
                    animation: showMenu ? "slideIn 350ms forwards" : "none",
                    "@keyframes slideIn": {
                      "0%": { opacity: 0.4, transform: "translateX(100px)" },
                      "100%": { opacity: 1, transform: "translateX(0)" },
                    },
                  }}
                >
                  <X
                    color="#000"
                    size={36}
                    sx={{
                      mt: 2.5,
                      mb: 0.75,
                      ml: "auto",
                      cursor: "pointer",
                      minHeight: 40,
                    }}
                    onClick={handleDrawerClose}
                  />
                  {menus.map((m, ind) => (
                    <RenderToggleMenu
                      key={m.id || ind}
                      menu={m}
                      type="drawer"
                    />
                  ))}
                </Box>
              </Drawer>
            </>
          ) : (
            <>
              <Box className="max-w-[900px] flex  justify-start">
                {menus.map((m, ind) => (
                  <RenderMenu key={m.id || ind} position={ind} menu={m} />
                ))}
              </Box>
            </>
          )}
        </Container>
      </Container>
    </div>
  );
};

export default Header;
